module.exports = __webpack_public_path__ + "static/img/2_1_2.f4a20a22.jpg";